import { useEffect } from 'react'
import type { ReactElement } from 'react'

import { useSession } from 'next-auth/react'

// eslint-disable-next-line
import type { default as Braze } from '@braze/web-sdk'
import useBrazeIntegration from '@context/useBrazeIntegration'

import Auth from '@components/profile/Auth'

declare global {
	interface Window {
		braze: typeof Braze
	}
}

export default function ProfileOrAuth({ children }: { children: ReactElement | null }) {
	const { status, data: session } = useSession()

	const { brazeFunction, getBrazeExternalId } = useBrazeIntegration()

	useEffect(() => {
		const brazeExternalId = getBrazeExternalId(session)

		if (brazeExternalId) {
			;(async () => {
				const braze = await brazeFunction()

				if (braze) {
					braze.getUser()?.getUserId((userId: string | null) => {
						if (userId !== brazeExternalId) {
							braze.changeUser(brazeExternalId)
							braze.openSession()

							if (session?.user?.customer?.email) {
								braze.getUser()?.setEmail(session?.user?.customer?.email)
							}
						}
					})
				}
			})()
		}
	}, [session, brazeFunction])

	if (status === 'loading') return null
	if (status === 'unauthenticated')
		return (
			<div className="flex justify-center pt-12 pb-20">
				<Auth step="login" />
			</div>
		)

	return children
}
